<template>
  <div class="row">
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <div class="col-md-12">
      <p class="clearfix"></p>
      <div class="category-top-bar">
        <div class="top-bar">
          <p>
            <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
              <i class="ti-arrow-left"></i>
              {{ $t('general.back') }}
            </a>
          </p>
        </div>
      </div>
      <div class="card">
        <div class="card-content row">
          <div class="col-sm-12">
            <div class="middle" style="height:100%; max-width: 300px; margin: auto;text-align: center;">
              <img v-if="qr_code" :src="qr_code" alt="qrCodeGroup">
              <br  v-if="qr_code">
              <br  v-if="qr_code">
              <a v-if="qr_code"
              class="btn btn-info btn-primary"
              style="width: 100%;"
              :href="this.apiUrl + '/settings/download?token=' + this.$session.get('token') + '&url=' + qr_code + '&name=' + group_name + ' ' + '.png'"
              target="_blank">{{$t('upload.download')}}</a>
              <br>
              <br>
              <a class="btn btn-info btn-primary" @click="regenerateQr()" style="width: 100%;">{{ $t('general.regenerateQr') }}</a>
            </div>
          </div>
        </div>
        <div class="card-content row">
          <div class="col-sm-12">
            <div class="pull-left search-filter" style="display: flex; align-items: center; gap: 10px; margin-bottom: 15px;">
              <input
                type="text"
                class="form-control"
                v-model="searchQuery"
                @keyup.enter="handleSearch"
                :placeholder="$t('customers.searchPlaceholder')"
                style="width: 300px;"
              />
              <button class="btn btn-icon btn-info" @click="handleSearch" :title="$t('general.search')">
                <i class="ti-search"></i>
              </button>
              <button v-if="searchQuery" class="btn btn-icon btn-default" @click="clearSearch" :title="$t('general.clear')">
                <i class="ti-close"></i>
              </button>
            </div>
            <div class="pull-right">
              <!-- spațiu pentru alte butoane -->
            </div>
          </div>
          
          <div class="col-sm-12 add-customer-div">
            <input type="text"
              @focusout="handleFocusOut"
              @keydown.esc="handleFocusOut"
              aria-autocomplete="off"
              :placeholder="$t('customers.addCustomerToGroup') || 'Add customer to group...'"
              id="add_customer"
              class="form-control"
              autocomplete="off"
              v-model="new_client.name"
              title="name"
              v-on:keyup="searchByName()"
            />
            <div class="inputWithSearch_search" v-if="existingNames.length">
              <template v-for="client in existingNames">
                <div class="client" @click="selectClient(client)" :key="client.id">
                  <div class="client__details">
                    <span v-if="client.firstname">{{client.firstname}}</span>
                    <span v-if="client.lastname">{{client.lastname}}</span>
                    <span v-if="!client.firstname && !client.lastname">{{client.email}}</span>
                  </div>
                  <div class="client__adress">
                    <span v-if="client.phone">{{client.phone}}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <data-tables class="campaign-table"
                    v-loading="loading"
                    :data="clientsTableData"
                    :pagination-def="paginationDef"
                    :table-props="{'border': false}"
                    :filters="filters"
                    style="width: 100%">
                  <el-table-column
                    :min-width="30"
                    :label="$t('customers.name')">
                    <template slot-scope="props">
                     <span>{{props.row.customer.firstname}}  {{ props.row.customer.lastname }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    :min-width="30"
                    :label="$t('customers.email')">
                    <template slot-scope="props">
                      <span>{{props.row.customer.email}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    :min-width="25"
                    :label="$t('customers.phone')">
                    <template slot-scope="props">
                      <span>{{props.row.customer.phone}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    :min-width="20"
                    :label="$t('customers.approvalStatus')">
                    <template slot-scope="props">
                      <span v-if="props.row.is_approved == 1" class="approved-badge">
                        <i class="ti-check" style="color: #28a745;"></i>
                        {{ $t('customers.approved') }}
                      </span>
                      <a
                        v-else
                        class="btn btn-warning btn-icon approve-btn"
                        :title="$t('customers.approve')"
                        @click="approveClient(props.row)">
                        <i class="ti-check"></i>
                        {{ $t('customers.approve') }}
                      </a>
                    </template>
                  </el-table-column>

                  <el-table-column
                    :min-width="12"
                    :label="$t('marketingOffers.actions')">
                    <template slot-scope="props">
                      <a
                        class="btn delete mar-rt-10"
                        :title="$t('general.delete')"
                        @click="removeClient(props.row)">
                        <img src="/static/img/icons/icon-close.png">
                        {{$t('general.delete')}}
                      </a>
                    </template>
                  </el-table-column>
          </data-tables>
          
          <el-pagination
            class="active-pagination"
            :total="paginationDef.totalRecords"
            :page-size="paginationDef.perPage"
            :pager-count="pagesCount"
            :current-page="paginationDef.page"
            layout="prev, pager, next, total"
            @current-change="handlePageChange($event)"
            @prev-click="handlePageChange($event)"
            @next-click="handlePageChange($event)">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  export default {
    components: {
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        loading: false,
        qr_code: null,
        group_name: '',
        apiUrl: '',
        offerModel: {},
        client: null,
        new_client: {},
        existingNames: [],
        clientsTableData: [],
        not2timeByName2: 1,
        searchQuery: '',  // <-- NOU
        modelValidations: {
          required: {
            required: true
          }
        },
        filters: [
          {
            value: '',
            prop: ['name', 'status', 'type']
          }
        ],
        paginationDef: {
          pageSize: 10,
          currentPage: 1,
          pageSizes: [5, 25, 50],
          show: false,
          perPage: 5
        },
        pagesCount: 5
      }
    },
    created: function () {
      this.apiUrl = process.env.API_BASE_URL
      let postData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        group_id: this.route.params.id
      }
      this.getClients(postData)
    },
    methods: {
      handleSearch () {
        let postData = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          group_id: this.route.params.id,
          search: this.searchQuery.trim()
        }
        this.getClients(postData)
      },
      clearSearch () {
        this.searchQuery = ''
        let postData = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          group_id: this.route.params.id
        }
        this.getClients(postData)
      },
      regenerateQr () {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          group_id: this.route.params.id
        }
        this.apiRequest('/customersgroup/regenerate-qr', 'POST', data, (response) => {
          if (response.status === true) {
            this.qr_code = response.data.qr_code
            this.$nextTick(function () {
              this.loading = false
            })
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            ).catch(() => {})
          }
        })
      },
      handlePageChange (page) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          group_id: this.route.params.id,
          page: page,
          perPage: this.paginationDef.perPage,
          filters: this.filters
        }

        if (this.searchQuery.trim()) {
          data.search = this.searchQuery.trim()
        }

        this.getClients(data)
      },
      searchByName () {
        if (this.not2timeByName2) {
          if (this.new_client.name === '') {
            this.existingNames = []
          } else {
            this.not2timeByName2 = 0
            this.existingClients = []
            this.existingPhones = []
            this.existingEmails = []
            this.existingNames = []
            setTimeout(() => {
              var data = {
                search: this.new_client.name,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany'),
                group_id: this.route.params.id
              }
              this.apiRequest('/search-for-client', 'GET', data, (response) => {
                if (response.status === true) {
                  this.existingNames = response.data.clients
                  this.loading = false
                }
                this.not2timeByName2 = 1
              })
            }, 500)
          }
        }
      },
      selectClient (client) {
        this.client = client
        this.existingNames = []
        this.new_client = {}

        // api call
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          group_id: this.route.params.id,
          client_id: this.client.id
        }
        this.apiRequest('/customersgroup/add-client', 'POST', data, (response) => {
          if (response.status === true) {
            this.clientsTableData.push(response.data)
            this.$nextTick(function () {
              this.loading = false
            })
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            ).catch(() => {})
          }
        })
      },
      getClients (data) {
        this.loading = true
        this.apiRequest('/customersgroup/list', 'GET', data, (response) => {
          if (response.status === true) {
            this.clientsTableData = response.data.customers
            this.paginationDef.page = response.data.pagination.page
            this.paginationDef.perPage = response.data.pagination.perPage
            this.paginationDef.totalPages = response.data.pagination.totalPages
            this.paginationDef.totalRecords = response.data.pagination.totalRecords
            this.qr_code = response.data.qr_code
            this.group_name = response.data.name
            this.$nextTick(function () {
              this.loading = false
            })
          }
        })
      },
      approveClient (item) {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          xref_id: item.id,
          is_approved: 1
        }
        this.apiRequest('/customersgroup/approve-client', 'POST', data, (response) => {
          if (response.status === true) {
            item.is_approved = 1
            swal(
              this.$t('general.success') + '!',
              this.$t('customers.clientApproved') || 'Client aprobat cu succes!',
              'success'
            ).catch(() => {})
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            ).catch(() => {})
          }
        })
      },
      removeClient (item) {
        let idx = null
        this.clientsTableData.forEach((el, index) => { if (el.id === item.id) { idx = index } })
        swal({
          text: this.$t('marketingCampaigns.areYouSureDelete') + ` '${item.customer.firstname} ${item.customer.lastname}'?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany')
            }
            this.apiRequest('/customersgroup/remove-client/' + item.id, 'DELETE', data, (response) => {
              if (response.status === true) {
                swal(
                  '',
                  this.$t('customers.deleteGroup'),
                  'success'
                )
                this.clientsTableData.splice(idx, 1)
              } else {
                swal(
                  '',
                  this.$t('validations.wentWrong'),
                  'error'
                )
              }
            })
          }
        }).catch(() => {
        })
      },
      handleFocusOut () {
        setTimeout(() => {
          this.existingNames = []
          this.new_client.name = ''
        }, 600)
      },
      backButton () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style scoped>
  .inputWithSearch_search {
    position: absolute;
    left: 15px;
    right: 15px;
    margin-top: 45px;
    background: white;
    border: 1px solid rgb(142, 103, 185);
    border-top: 0;
    max-height: 360px;
    overflow: auto;
    z-index: 1;
  }
  .client {
    padding: 10px;
    font-size: 1.2em;
    /* display: flex; */
    border-bottom: 1px solid #ccc;
    color: #777777;
  }
  .client:hover {
    /* background-color: #e7e4e4; */
    background-color: #f0ebfffc;
  }
  .add-customer-div {
    display:flex;
    margin-bottom: 3%;
  }
  #add_button {
    align-items: center;
    align-self: center;
    position: absolute;
    right: 0;
    margin-right: 17px;
    background: #398439;
    padding: 10px 30px;
    border-radius: 10px;
    color: #fff;
    height: 45px;
    width: 79px;
    font-size: 1.3em;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  #add_button:hover {
    background: #2fc92f;
  }
  .sortableRow tr:hover {
    background-color: #f5f5f5;
  }
  .approved-badge {
    color: #28a745;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .approve-btn {
    background-color: #f0ad4e;
    border-color: #eea236;
    color: #fff;
    padding: 5px 12px;
    border-radius: 4px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
  }
  .approve-btn:hover {
    background-color: #ec971f;
    border-color: #d58512;
  }
  .approve-btn i {
    font-size: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Customers/Groups/GroupView.vue